module.exports = __webpack_public_path__ + "c180f7a2.svg";